import React from 'react';
import {
    VStack,
    FormControl,
    FormLabel,
    Input,
    Button,
    Text,
    Box,
    Divider,
    HStack,
} from '@chakra-ui/react';

export default function UpdateProfileProperties({
    nodeConfig,
    setNodeConfig,
    updateNodeData,
    setSelectedNode
}) {
    return (
        <VStack spacing={4} align="stretch">
            <FormControl>
                <FormLabel fontSize="sm">Step Name</FormLabel>
                <Input
                    size="sm"
                    value={nodeConfig.label}
                    onChange={(e) => setNodeConfig({ ...nodeConfig, label: e.target.value })}
                    placeholder="e.g., Update Customer Profile"
                />
            </FormControl>

            <FormControl>
                <FormLabel fontSize="sm">Tag Name</FormLabel>
                <Input
                    size="sm"
                    value={nodeConfig.tagName || ''}
                    onChange={(e) => setNodeConfig({ ...nodeConfig, tagName: e.target.value })}
                    placeholder="e.g., total_amount"
                />
                <Text fontSize="xs" color="gray.600" mt={1}>
                    The customer profile attribute to update
                </Text>
            </FormControl>

            {/* <FormControl>
                <FormLabel fontSize="sm">Tag Value (Optional)</FormLabel>
                <Input
                    size="sm"
                    value={nodeConfig.tagValue || ''}
                    onChange={(e) => setNodeConfig({ ...nodeConfig, tagValue: e.target.value })}
                    placeholder="e.g., 100 or {{variable_name}}"
                />
                <Text fontSize="xs" color="gray.600" mt={1}>
                    Static value or dynamic variable using {`{{variable_name}}`}
                </Text>
            </FormControl> */}

            <Box p={3} bg="blue.50" borderWidth="1px" borderColor="blue.200" borderRadius="lg">
                <Text fontSize="xs" fontWeight="medium" color="blue.900" mb={1}>
                    About Profile Updates
                </Text>
                <Text fontSize="xs" color="blue.800">
                    This node updates customer profile attributes/tags in your database. Use it to track customer journey progress, preferences, or custom attributes.
                </Text>
            </Box>

            <Divider />

            <HStack>
                <Button
                    size="sm"
                    variant="outline"
                    onClick={() => setSelectedNode && setSelectedNode(null)}
                >
                    Cancel
                </Button>
                <Button
                    size="sm"
                    colorScheme="green"
                    onClick={updateNodeData}
                    flex={1}
                    isDisabled={!nodeConfig.tagName}
                >
                    Update Node
                </Button>
            </HStack>

            {!nodeConfig.tagName && (
                <Text fontSize="xs" color="orange.600" textAlign="center">
                    Tag name is required to update the node
                </Text>
            )}
        </VStack>
    );
}
